import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { isProjectTypeMember } from "@/core/lib/access";
import {
  AUDIT_PROJECT_TYPE,
  CORPORATE_FINANCE_PROJECT_TYPE,
} from "@/core/lib/constants";
import { DEPARTMENT_PROJECT_TYPES } from "@/core/lib/project-types";
import { denyRouteAccess } from "@/core/lib/route-access";

export const Route = createFileRoute(
  "/_protected/template-editor/classification-templates/create/",
)({
  validateSearch: z.object({
    projectType: z.enum(DEPARTMENT_PROJECT_TYPES).optional(),
  }),
  beforeLoad: ({ context, search, ...guard }) => {
    const projectType = search.projectType ?? AUDIT_PROJECT_TYPE;
    if (!isProjectTypeMember(context.user, projectType)) {
      denyRouteAccess(guard, `${projectType}_membership`);
    }
    if (projectType === CORPORATE_FINANCE_PROJECT_TYPE) {
      throw redirect({
        to: "/template-editor",
        search: {
          status: "approved",
          category: "classifications",
          projectType,
        },
        replace: true,
      });
    }
    if (!search.projectType) {
      throw redirect({
        to: "/template-editor/classification-templates/create",
        search: { projectType },
        replace: true,
      });
    }
  },
  loader: ({ context }) => {
    const organizationId = context.user.organization?.id;

    if (!organizationId) {
      throw redirect({ to: "/no-organization", throw: true });
    }
  },
});
